<template>
  <v-card v-if="transProgData.length > 0">
    <v-simple-table dense>
      <tbody>
        <tr
          v-for="(trnsProg, index) in transProgData"
          :key="'transfer_progress_tr_' + index"
        >
          <th>
            <v-icon>{{
              trnsProg.isUpload ? "mdi-upload" : "mdi-download"
            }}</v-icon>
          </th>
          <td>
            <span
              ><v-icon>mdi-clock</v-icon> {{ $i18n.t("Proceesing From ")
              }}{{ trnsProg.startedAt | moment("DD MMM YYYY hh:mm a") }}
            </span>
            <span v-if="trnsProg.completedAt"
              ><v-icon>mdi-clock</v-icon> {{ $i18n.t(" till ")
              }}{{ trnsProg.completedAt | moment("DD MMM YYYY hh:mm a") }}
            </span>
          </td>
          <td>
            <span v-show="trnsProg.total">
              {{ $i18n.t("Tasks") }}: {{ trnsProg.completed }}/{{
                trnsProg.total
              }}
            </span>
          </td>
          <td>
            <span v-show="trnsProg.uploadLink"
              ><a :href="trnsProg.uploadLink" v-show="trnsProg.uploadLink">{{
                $i18n.t("Uploaded File")
              }}</a></span
            >
          </td>
          <td>
            <span v-show="trnsProg.downloadLink"
              ><a :href="trnsProg.downloadLink" v-show="trnsProg.downloadLink">
                {{ $i18n.t("Download") }}
                {{
                  trnsProg.status == 1
                    ? $i18n.t("Response")
                    : $i18n.t('"Fault Sheet')
                }}
              </a></span
            >
          </td>
          <td></td>
          <td>
            <span v-show="trnsProg.status == 0"
              ><v-btn text small color="info">
                {{ $i18n.t("In Progress") }}
              </v-btn></span
            >
            <span v-show="trnsProg.status == 1"
              ><v-btn text small color="success">
                {{ $i18n.t("Completed") }}
              </v-btn></span
            >
            <span v-show="trnsProg.status == 2"
              ><v-btn text small color="error">
                {{ $i18n.t("Failed") }}
              </v-btn></span
            >
          </td>
          <td>
            <v-btn
              class="float-right"
              @click="deleteTP(trnsProg._id)"
              fab
              text
              small
              color="error"
            >
              <v-icon>mdi-minus-circle-outline</v-icon>
            </v-btn>
          </td>
        </tr>
      </tbody>
    </v-simple-table>
  </v-card>
</template>

<script>
import { Vue, Component, Watch } from "vue-property-decorator";
import common from "@/store/common/module/common";
import { doPost, doGet } from "@/store/common/module/apis";
import corpService from "@/store/common/module/CorpService";

@Component({
  name: "TransferProgress",
  props: {
    kclass: {
      default: null,
    },
    reload111: {
      default: null,
    },
    label: {
      default: "Transfer Progress",
    },
  },
})
export default class TransferProgress extends Vue {
  transProgData = [];

  async getData() {
    this.transProgData = await doGet(
      `/api/transfer/progress/${this.kclass}/list`
    );
    if (this.transProgData && this.transProgData.length > 0) {
      for (let i = 0; i < this.transProgData.length; i++) {
        if (this.transProgData[i].status == 0) {
          setTimeout(() => {
            this.getData();
          }, 10000);
          break;
        }
      }
    }
  }

  async deleteTP(id) {
    try {
      common.setLoading(true);
      await doGet(`/api/transfer/progress/${id}/delete`);
      // common.showMessage("Delete Success.");
      this.getData();
      common.setLoading(false);
    } catch (e) {
      common.setLoading(false);
      common.setError(e);
    }
  }

  async mounted() {
    this.getData();
  }

  get loading() {
    return common.loading;
  }

  @Watch("kclass")
  onKclassChange(val) {
    this.getData();
  }

  @Watch("reload111")
  onRealodChange(val) {
    this.getData();
  }
}
</script>
